import React from 'react';

const AddNeed = () => <div>add need page</div>;

export default AddNeed;
